import { render, staticRenderFns } from "./interviewRating.vue?vue&type=template&id=5c6fbdfa&scoped=true"
import script from "./interviewRating.vue?vue&type=script&lang=js"
export * from "./interviewRating.vue?vue&type=script&lang=js"
import style0 from "./interviewRating.vue?vue&type=style&index=0&id=5c6fbdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fbdfa",
  null
  
)

export default component.exports